<div
  class="med-tab"
  [ngClass]="classList"
>
  <ng-content></ng-content>
</div>
